import "./MassageTherapy.module.css";
import Header from "@/reusable_sections/Header";
import MassageTherapyCourseSummary from "./sections/MassageTherapyCourseSummary";
import DetallesDelCurso from "./sections/DetallesDelCurso";
import InvitacionAInscribirse from "./sections/InvitacionAInscribirse";
import Footer from "@/reusable_sections/Footer";
export default function MassageTherapyPage() {
  return <div>
      <Header />
      <MassageTherapyCourseSummary />
      <DetallesDelCurso />
      <InvitacionAInscribirse />
      <Footer />
    </div>;
}